
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Rocket from 'plaid-threads/Icons/Rocket';
import Libraries from 'plaid-threads/Icons/Libraries';
import Overview from '../../../../components/docs/Overview';
import Actions from '../../../../components/docs/Actions';
export const metadata = {
  toc: true,
  layout: 'guide',
  section: 'Virtual Accounts',
  title: 'Introduction',
  description: 'Manage the entire lifecycle of a payment'
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Overview.Header product={'Virtual Accounts'}>
  {metadata.description}
    </Overview.Header>
    <Actions.SmallWrapper miniTitle='Get started with Virtual Accounts'>
  <Actions.SmallCard icon={<Libraries mdxType="Libraries" />} title='API Reference' link='/docs/api/products/virtual-accounts/' />
  <Actions.SmallCard icon={<Rocket mdxType="Rocket" />} title='Getting Started Guide' link='/docs/payment-initiation/virtual-accounts/add-to-app' />
    </Actions.SmallWrapper>
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid's Virtual Accounts API allows you to collect domestic payments, initiate payouts and refunds, and streamline reconciliation processes. Virtual accounts provide granular control and visibility throughout the entire lifecycle of a payment. Virtual accounts can be used independently, or can be layered on top of Payments functionality to provide insight into the settlement status of all transactions, pay out to your merchants, allow end users to withdraw their funds, and issue refunds.`}</p>
    <p>{`For example, if you have a brokerage app, you can use `}<a parentName="p" {...{
        "href": "/docs/payment-initiation"
      }}>{`One-Time Payment Initiation`}</a>{` for end users to fund their accounts. `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/payment-confirmation/"
      }}>{`Payment Confirmation`}</a>{` will inform you when your end users' payments have settled so you can release these funds for your end users to purchase equities. When your end users sell their equity purchases, you can use `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/payouts"
      }}>{`Payouts`}</a>{` to let them cash out their earnings.`}</p>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/add-to-app"
      }}>{`Add Virtual Accounts to your App`}</a>{` guide to learn more about how to implement virtual accounts.`}</p>
    <h4 {...{
      "id": "testing-virtual-accounts"
    }}>{`Testing Virtual Accounts`}</h4>
    <p>{`For Sandbox or Production access to Virtual Accounts, you will need to first `}<a parentName="p" {...{
        "href": "https://plaid.com/contact"
      }}>{`contact sales`}</a>{` or your account manager.`}</p>
    <h4 {...{
      "id": "next-steps"
    }}>{`Next steps`}</h4>
    <p>{`To get started building with Virtual Accounts, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/add-to-app"
      }}>{`Add Virtual Accounts to your App`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "testing-virtual-accounts",
        level: 4,
        title: "Testing Virtual Accounts",
      },
{
        id: "next-steps",
        level: 4,
        title: "Next steps",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
